type SingleOption = {
  children: string | string[] | object[] // the user friendly text of the option
  key: string // the id of the option
  value: string // the id of the option
}

type OptionGroup = {
  key: string
  label: string // text of the group
  options: SingleOption[]
}

type SingleOrGroup = SingleOption | OptionGroup

const searchChildren = (child: object, input) => {
  const children = child['props']?.['children']

  if (typeof children === 'string') {
    return children.toLowerCase().includes(input.toLowerCase())
  } else if (Array.isArray(children)) {
    const joinedChildren = children.join(' ')
    return joinedChildren.toLowerCase().includes(input.toLowerCase())
  } else if (typeof children === 'object') {
    return searchChildren(children, input)
  }
  return false
}

export const filterSelect = (input: string, singleOrGroup: SingleOrGroup) => {
  if (!input) return true

  if (Array.isArray((singleOrGroup as OptionGroup).options)) {
    return false // do not filter groups, wait for individual options
  }

  const option = singleOrGroup as SingleOption

  if (!option.children) return false

  if (Array.isArray(option.children)) {
    return option.children.some((child) => {
      if (!child) return false

      if (typeof child === 'string') {
        return child.toLowerCase().includes(input.toLowerCase())
      }

      return searchChildren(child, input)
    })
  } else if (typeof option.children === 'object' && option.children !== null) {
    return searchChildren(option.children, input)
  } else if (typeof option.children === 'string') {
    return option.children.toLowerCase().includes(input.toLowerCase())
  } else {
    return false
  }
}
